import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import EcgLoader from '../Components/Shared/EcgLoader';
// import { Chat } from '../providers';
import { getUser, getUserStart } from '../Store/actions/user';
import { checkAuthentication, clearResetIdleTime,getToken } from './AuthUtilities';
import {ChatProvider} from '@alivecor/strophe2.0'

const withAuth = (parentProps) =>
  function (Comp) {
    return function HasAuth(props) {
      const { profile,chatProfile, team, isAuthenticated, login, loading } = useSelector((state) => state.user);
      
      const dispatch = useDispatch();

      useEffect(() => {
        dispatch(checkAuthentication());
      }, [dispatch]);

      useEffect(() => {
        if (!login && !profile && !loading) {
          if(getToken()){
            dispatch(getUserStart());
          dispatch(getUser());
          }
        }
      }, [login]);

      if (isAuthenticated) {
        if (profile) {
          parentProps.userstate.data.profile = profile;
          parentProps.userstate.data.teams = [team];
          return (
            <ChatProvider userId={chatProfile?.kccChatUserID} password={chatProfile?.kccChatPassword}>
              <Comp {...props} {...parentProps} />
            </ChatProvider>
          );
        }
        return <EcgLoader />;
      }
      clearResetIdleTime();
      return <Redirect to={{ pathname: '/login' }} />;
    };
  };

export default withAuth;
